// extracted by mini-css-extract-plugin
export default {"columnHeader":"b5LXC","revisionsWrapper":"GIjOu","schemaSeparator":"G5XmZ av9xi Ci8uE","tableActualName":"iYspr"};